import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M3 16.281c0-3.866 1.5-5.706 4-7l2.5 3.294-2.147 3.706H3Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21 16.114c0-3.866-1.5-5.706-4-7l-2.5 3.294 2.148 3.706H21Zm-4-7.206c-4-3.425-7.322-1.366-10-.5l2.5 4.5 5-.5 2.5-3.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.428 15.95H6.92c.058-.41.166-.804.318-1.176l-1.072-.585a.7.7 0 1 1 .67-1.229l1.107.604c.206-.262.438-.502.692-.718L6.72 9.861a8.588 8.588 0 0 0-3.292 6.089Zm4.463-6.857L9.82 12.1a4.895 4.895 0 0 1 2.001-.425c.821 0 1.595.202 2.276.558l2.013-3.14A8.562 8.562 0 0 0 12 8.05a8.562 8.562 0 0 0-4.109 1.043Zm9.389.768-2.046 3.191a4.986 4.986 0 0 1 1.487 2.898h3.85a8.588 8.588 0 0 0-3.291-6.09Zm-8.084 4.387a3.531 3.531 0 0 1 2.624-1.173c1.955 0 3.55 1.609 3.55 3.575a.7.7 0 0 0 .7.7h5.23a.7.7 0 0 0 .7-.7c0-5.523-4.477-10-10-10s-10 4.477-10 10a.7.7 0 0 0 .7.7h4.87a.7.7 0 0 0 .7-.7c0-.42.073-.824.207-1.2l3.188 1.74a.7.7 0 1 0 .67-1.23l-3.14-1.712Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=MeterOneIcon24.js.map